/* ============================================================
Fossa Variation System — fossa-variation.js (Option A)
Defensive, READ-ONLY enhancement of the EXISTING Avis Plus
(Aris Options) swatch markup. It ONLY:
1. Marks the swatch representing the current product as active
(by swatch link URL, else by option value vs product title).
2. Renders a "Color - <Selected Value>" label next to the title.
It NEVER intercepts Avis clicks, never changes cart, price, SKU,
Add to Cart, Buy Now, app data, or product data.
============================================================ */
(function () {
  "use strict";
  
  var SCOPE = ".fossa-vary";
  
  function clean(s) {
    return (s || "").toString().trim().toLowerCase();
  }
  
  function normalizeUrl(href) {
    if (!href) return "";
    try {
      return new URL(href, window.location.origin).pathname
      .replace(/\/+$/, "").toLowerCase();
    } catch (e) {
      return String(href).split("?")[0].replace(/\/+$/, "").toLowerCase();
    }
  }
  
  function currentPath() {
    return window.location.pathname.replace(/\/+$/, "").toLowerCase();
  }
  
  function productHaystack() {
    var t = clean(document.title);
    var h = currentPath().replace(/[-\/]/g, " ");
    return t + " " + h;
  }
  
  function swatchValue(wrap) {
    var t = wrap.querySelector(".swatch-variant-title");
    if (t && clean(t.textContent)) return clean(t.textContent);
    var inp = wrap.querySelector("input[value]");
    if (inp) return clean(inp.getAttribute("value"));
    return "";
  }
  
  function markActiveSwatch(root) {
    var cur = currentPath();
    var hay = productHaystack();
    var wraps = root.querySelectorAll(
      ".avp-productoptionswatchwrapper, .apo-swatch-wrapper"
    );
    
    var matched = false;
    wraps.forEach(function (w) {
      var link = w.querySelector("a.apo-swatch-a, a.apo-swatch-url, a[href]");
      if (!link) return;
      if (normalizeUrl(link.getAttribute("href")) === cur) {
        w.classList.add("fossa-active");
        matched = true;
      }
    });
    if (matched) return;
    
    var best = null;
    var bestLen = 0;
    wraps.forEach(function (w) {
      var val = swatchValue(w);
      if (val && hay.indexOf(val) !== -1 && val.length > bestLen) {
        best = w;
        bestLen = val.length;
      }
    });
    if (best) best.classList.add("fossa-active");
  }
  
  function renderSelectedLabel(root) {
    var groups = root.querySelectorAll(".avp-option");
    groups.forEach(function (group) {
      var label =
      group.querySelector(".ap-label-tooltip") ||
      group.querySelector(".avp-productoptiontitle");
      if (!label) return;
      
      var value = "";
      var active = group.querySelector(".fossa-active");
      if (active) value = swatchValue(active);
      if (!value) {
        var checked = group.querySelector("input:checked[value]");
        if (checked) value = clean(checked.getAttribute("value"));
      }
      
      var existing = label.querySelector(".fossa-selected-value");
      if (!value) {
        if (existing) existing.remove();
        return;
      }
      var display = value.replace(/\b\w/g, function (c) {
        return c.toUpperCase();
      });
      if (existing) {
        existing.textContent = display;
      } else {
        var span = document.createElement("span");
        span.className = "fossa-selected-value";
        span.textContent = display;
        label.appendChild(span);
      }
    });
  }
  
  function enhance() {
    var root = document.querySelector(SCOPE) || document;
    if (!root.querySelector(".avpoptions-container__v2, .avp-option")) return;
    markActiveSwatch(root);
    renderSelectedLabel(root);
  }
  
  function init() {
    enhance();
    var target = document.querySelector(SCOPE) || document.body;
    if (!target) return;
    
    var debounce;
    var observer = new MutationObserver(function () {
      window.clearTimeout(debounce);
      debounce = window.setTimeout(enhance, 150);
    });
    observer.observe(target, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 15000);
  }
  
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
